import { render } from "./ServiceDetail.vue?vue&type=template&id=0a6403de"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Work/AUM 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__